export default __webpack_public_path__ + "static/media/Reader's Bracers of Twining Smoke.85e092ac.jpg";